import { Col, Radio, Row } from "antd";

import { usePublicationDate } from "./PublicationDate.hook";
import { useTheme } from "../../../Styles/ThemeHook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import {
    publicationDate,
} from "../../../ViewFragments/SearchResults/Sider/TopBarFilters/options"
import ButtonGroup from "../ButtonGroup/web";
import { useState } from "react";
import { ArrowIcon } from "shared-components/Components/CustomIcons/ArrowIcon/web";

export const PublicationDate = ({ collapsable = false, inputType = "checkbox", filterChanged, showUpTo = null}) => {
	const { theme } = useTheme();
	const {
		show,
		data: { value = null },
	} = usePublicationDate();
	let filter = null;
	const [showMore, setShowMore] = useState(false);

	if (!show) return null;

	const handleChange = (newValue) => {

		if(value === newValue) {
			handleClearFilter();
		}
        const selectedOption = publicationDate.filter((option) => newValue === option.value)[0];
		
        if (selectedOption) filterChanged({ publicationDate: {text: selectedOption.text, value: selectedOption.value} });
		else handleClearFilter();
    }

    const handleClearFilter = () => {
        filterChanged({ publicationDate: null })
    }

	if (inputType === "radio") {
		filter = (
			<Radio.Group onChange={handleChange} value={value}>
				<Row gutter={[0, theme.spacing.lgSpacing]}>
					<Col span={24}>
						<Radio value={-1}>{"Indiferente"}</Radio>
					</Col>
					{publicationDate?.map(option => (
						<Col span={24} key={`key_${option.value}_publicationDate`}>
							<Radio value={option.value}>{option.text}</Radio>
						</Col>
					))}
				</Row>
			</Radio.Group>
		);
	} else if (inputType === "buttonGroup") {
		filter = (
			<>
				<div className="filter__scrollable-box">
					<ButtonGroup
						options={publicationDate.map(option => {return {text: option.text, value: option.value}})}
						selected={value}
						onChange={handleChange}
						cleanFilter={handleClearFilter}
						optionForAny={{text: 'Todos', value: null}}
					/>
				</div>

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
		);
	} else if (inputType === "boxes") {
		filter = (
			<div className="boxes-container">
			  	{publicationDate.map((o,i) =>
					{
						return (!showUpTo || showMore || (i < showUpTo && !showMore)) && (
							<div
								key={o.value}
								className={`boxes-container__item ${value === o.value ? "boxes-container__item--active " : ""}`}
								onClick={()=>{handleChange(o.value)}}
							>
								<span>{o.text}</span>
							</div>
						)
					}
				)}
	  
				{showUpTo && publicationDate.length > showUpTo && 
					<button className="show-more" onClick={()=>{setShowMore(!showMore)}}>
						{showMore ? 'Ver menos' : 'Ver más'}
						{showMore ? <ArrowIcon type="top" /> : <ArrowIcon type="bottom" />}
					</button>
				}

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</div>
		);
	}

	const label = "Fecha de publicación";

	return (
		<div className="filter publicationDate-filter">
			{collapsable ?
				<IC_Collapse label={label} isActive={value !== -1 && value >= 0} startOpen={value > 0}>
					{filter}
				</IC_Collapse> :
				<>
					<h3 className="filter-title">{label}</h3>
					{filter}
				</>
			}
		</div>
	);
};
